import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { MortgageMonthlyPaymentFilter } from 'shared/containers/MortgageMonthlyPaymentFilter';
import { useExperiment, useRuntimeSetting } from 'shared/hooks';
import { NEWBUILDING_MONTHLY_PAYMENT } from 'shared/constants/experiments';

export const MortgageMonthlyPaymentContainer: FC = () => {
  const isNewBuildingMonthlyPaymentExperimentEnabled = useExperiment(NEWBUILDING_MONTHLY_PAYMENT);
  const isEnabled = useRuntimeSetting('Newbuilding.MortgageMonthlyPayment.Enabled', false);
  const isOnboardingEnabled = useRuntimeSetting('Newbuilding.MortgageMonthlyPaymentOnboarding.Enabled', false);

  if (!isNewBuildingMonthlyPaymentExperimentEnabled || !isEnabled) {
    return null;
  }

  return (
    <AdvancedFilterRow label="Платёж по ипотеке" isNew={isOnboardingEnabled}>
      <InlineFilterGroup>
        <InlineFilter>
          <MortgageMonthlyPaymentFilter placeholder="до" />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
